import React, { useState, useEffect } from "react";
import { COMPANY } from "../data/site";
import { Menu, X, Phone } from "lucide-react";
import LanguageSwitcher from "./LanguageSwitcher";

const NAV = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Products", id: "products" },
  { label: "Industries", id: "industries" },
  { label: "Contact", id: "contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
    >
      <div
        className={`mx-auto max-w-7xl px-3 transition-all duration-300 ${
          scrolled ? "max-w-6xl" : "max-w-7xl"
        }`}
      >
        <div
          className={`flex items-center justify-between gap-3 transition-all duration-300 px-4 md:px-6 ${
            scrolled
              ? "h-16 rounded-full bg-white/85 backdrop-blur-xl border border-orange-100 shadow-[0_10px_40px_-15px_rgba(229,57,53,0.3)]"
              : "h-20"
          }`}
        >
          <a href="#home" data-testid="logo-link" className="flex items-center gap-3 shrink-0">
            <div
              className={`rounded-md transition-colors ${
                scrolled ? "bg-white p-1" : "bg-white/95 p-1.5"
              }`}
            >
              <img src={COMPANY.logo} alt="ESS BEE HEATERS" className="h-9 w-auto" />
            </div>
            <div className="hidden sm:block">
              <div
                className={`font-display font-extrabold leading-tight tracking-tight ${
                  scrolled ? "text-base text-[#1a0a05]" : "text-lg text-white"
                }`}
              >
                ESS BEE HEATERS
              </div>
              <div
                className={`text-[9px] tracking-[0.3em] font-mono ${
                  scrolled ? "text-orange-700" : "text-amber-300"
                }`}
              >
                PRIVATE LIMITED
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                data-testid={`nav-${n.id}`}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                  scrolled ? "text-[#1a0a05] hover:bg-orange-100" : "text-white/90 hover:bg-white/10"
                }`}
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <LanguageSwitcher dark={!scrolled} />
            <a
              href={`tel:${COMPANY.contacts[0].phone}`}
              data-testid="navbar-call-btn"
              className="hidden md:inline-flex items-center gap-2 heat-gradient text-white px-5 py-2.5 rounded-full text-sm font-bold shadow-lg shadow-red-500/30 hover:scale-[1.03] transition-transform"
            >
              <Phone className="w-4 h-4" />
              Call Now
            </a>
            <button
              className={`lg:hidden p-2 rounded-md ${scrolled ? "text-[#1a0a05]" : "text-white"}`}
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div
          className="lg:hidden mt-2 mx-3 bg-white rounded-3xl border border-orange-100 px-5 py-4 shadow-2xl"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col gap-1">
            {NAV.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-xl text-[#1a0a05] font-semibold hover:bg-orange-50"
                data-testid={`mobile-nav-${n.id}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href={`tel:${COMPANY.contacts[0].phone}`}
              className="mt-2 inline-flex items-center justify-center gap-2 heat-gradient text-white px-5 py-3 rounded-full text-sm font-bold"
            >
              <Phone className="w-4 h-4" /> {COMPANY.contacts[0].phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
